module.exports = __webpack_public_path__ + "static/media/Gold-Host-Distributor.2ac74c71.png";